class TmRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const STORAGE_KEY = 'tm_recently_viewed';
    const MAX_STORED = 9;
    const MAX_SHOWN = 4;

    const handle = this.dataset.productHandle;
    let stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      stored = [];
    }

    if (handle) {
      stored = stored.filter((h) => h !== handle);
      stored.unshift(handle);
      stored = stored.slice(0, MAX_STORED);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) { /* noop */ }
    }

    const toShow = stored.filter((h) => h !== handle).slice(0, MAX_SHOWN);
    if (toShow.length === 0) return;

    Promise.all(
      toShow.map((h) =>
        fetch('/products/' + h + '.js')
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      const valid = products.filter(Boolean);
      if (valid.length === 0) return;

      const grid = this.querySelector('[data-role="grid"]');
      grid.innerHTML = valid
        .map((p) => {
          const price = (p.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          const img = p.featured_image || (p.images && p.images[0]) || '';
          return (
            '<a href="' + p.url + '" class="tm-recent__card">' +
            '<span class="tm-recent__img-wrap"><img src="' + img + '&width=300" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></span>' +
            '<p class="tm-recent__name">' + p.title + '</p>' +
            '<p class="tm-recent__price">' + price + '</p>' +
            '</a>'
          );
        })
        .join('');

      this.hidden = false;
    });
  }
}

customElements.define('tm-recently-viewed', TmRecentlyViewed);
